<template>
    <div>
        <div class="support-tickets-header">
            <!-- <div class="tickets-filter">
                <div class="form-group mr-3">
                    <label class="d-none d-md-inline-block mr-2">Status</label>
                    <select class="form-control-sm" v-model="selectedStatus" @change="onChange">
                        <option v-for="(status, index) in imageStatusOptions" :value="imageStatus" @change="filterImages()" :selected="index == 0">{{status}}</option>
                    </select>
                </div>
            </div> -->
        </div>
        <div class="support-ticket" v-for="image in images">
            <div class="st-meta">
                <!-- <i class="fas fa-flag flagged" ></i> -->
                <!-- <i class="fas fa-check-circle" v-if="isQCApproved(product) == 1" :class="'qc-'+isQCApproved(product)"></i>
                <i class="fas fa-times-circle" v-if="isQCRejected(product) == 1" :class="'qc-'+isQCRejected(product)"></i> -->
            </div>
            <div class="st-body">
                <div class="avatar">
                    <img alt="" :src="getImage(image)" @click="zoomImage(image)">
                </div>
                <div class="col-sm-2">
                    <div class="ticket-content">
                        <h6 class="ticket-title">
                            Image {{image.id_image}}
                        </h6>
                        <div class="ticket-description">
                            Session {{image.id_photodesk_session}}
                        </div>
                        <div class="ticket-description">
                            {{image.extension}}
                        </div>
                    </div>
                </div>
                <div class="col-sm-2 b-r">
                    <div class="el-tablo centered padded-v">
                        <div class="value">
                            <i class="fal fa-check text-success" v-if="image.is_pretouch_approve == 1 && image.id_image != null"></i>
                            <i class="fal fa-exclamation-circle text-warning" v-else></i>
                            <br>
                            <span class="small-detail">{{product.retouch_sent_by}}</span> <br>
                            <span class="small-detail">{{product.retouch_sent_at}}</span><br>
                        </div>
                        <div class="label">Pretouch</div><br />
                        <a class="label btn btn-primary" @click="downloadImage(image, 'pretouch')">Download</a>
                    </div>
                </div>
                <div class="col-sm-2 b-r">
                    <div class="el-tablo centered padded-v">
                        <div class="value">
                            <i class="fal fa-check text-success" v-if="image.is_retouch_approve == 1 && image.id_image != null"></i>
                            <i class="fal fa-exclamation-circle text-warning" v-else></i>
                            <br>
                            <span class="small-detail">{{product.retouch_received_by}}</span> <br>
                            <span class="small-detail">{{product.retouch_received_at}}</span><br>
                        </div>
                        <div class="label">Retouch</div><br />
                        <a class="label btn btn-primary" @click="downloadRetouchImage(image, 'retouch')">Download</a>
                    </div>
                </div>
                <div class="col-sm-2 b-r">
                    <div class="el-tablo centered padded-v">
                        <div class="value">
                            <i class="fal fa-check text-success" v-if="image.final_sent_at != null && image.id_image != null"></i>
                            <i class="fal fa-exclamation-circle text-warning" v-else></i>
                            <br>
                            <span class="small-detail">{{product.final_sent_at}}</span> <br>
                            
                        </div>
                        <div class="label">Final</div> <br />
                        <a class="label btn btn-primary" @click="actionPendingProduct(image)">Resend</a>
                    </div>
                </div>
                <div class="col-sm-4">
                    <table class="table table-v-compact mb-0">
                        <tbody>
                            <tr>
                                <td>
                                    <strong class="text-danger" v-if="image.deleted_at"> Deleted</strong>
                                    <strong class="text-success" v-if="image.id_product_image && image.id_product_image != null"> Allocated</strong>
                                    <strong class="" v-else> Not Used</strong>
                                    <div class="balance-label smaller lighter text-nowrap">Status</div>
                                </td>
                            </tr>
                            <tr v-if="image.id_product_image && image.id_product_image != null">
                                <td>
                                    <strong class="text-success" > {{image.sequence}}</strong>
                                    <div class="balance-label smaller lighter text-nowrap">Slot</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>{{image.created_at}}</strong>
                                    <div class="balance-label smaller lighter text-nowrap">Shot On</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="st-foot">

                <!-- <span class="label">Contributors:</span> -->
                <span class="value" v-for="contributor in formatContributors(image)">
                    <div >
                        <span class="label">{{capitalize(contributor.role)}}</span>
                        <a class="value with-avatar">
                            <img alt="" :src="contributor.avatar">
                            <span>{{contributor.name}}</span>
                        </a>
                    </div>
                </span>
            </div>
            <div class="st-foot">
                <span class="value" v-if="image.retouch_location">
                    <div >
                        <span class="label">Retouch Location</span>
                        <span class="value">{{image.retouch_location}}</span>
                    </div>
                </span>
            </div>
            <div class="st-foot">
                <span class="value" v-if="image.final_location">
                    <div >
                        <span class="label">Final Location</span>
                        <span class="value">{{image.final_location}}</span>
                    </div>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import CommonFunctions from '@/mixins/common-functions.js'

export default {
  mixins: [CommonFunctions],
  props: ['product', 'images'],
  data () {
    return {
      imageStatusOptions: ['All Status', 'Allocated', 'Deleted'],
      imageStatus: 'All Status'
    }
  },
  methods: {
    getImage: function (image) {
      if (image) {
        return image.host + image.raw_thumb_location
      } else {
        return 'https://storage.googleapis.com/sb-prod-assets/Defaults/noimage.png'
      }
    },
    downloadFile (response, filename) {
    // It is necessary to create a new blob object with mime-type explicitly set
    // otherwise only Chrome works like it should
      var newBlob = new Blob([response.body], { type: '*/*' })

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob)
        return
      }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob)
      var link = document.createElement('a')
      link.href = data
      link.download = filename + '.png'
      link.click()
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data)
      }, 100)
    },
    downloadImage: function (image) {
      var self = this
      const url = '/imagedesk/image/download'
      let data = {
        id_image: image.id_image
      }
      this.$http
        .post(url, data, {
          dataType: 'json',
          responseType: 'blob',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', self.product.item_identifier + '_' + image.sequence + '.' + image.extension)
          document.body.appendChild(link)
          link.click()
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: 'Something went wrong',
            show: true
          })
        })
    },

    downloadRetouchImage: function (image) {
      var self = this
      const url = '/imagedesk/image/downloadRetouch'
      let data = {
        id_image: image.id_image
      }
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          const link = document.createElement('a')
          link.href = response.data['data']
          link.target = '_blank'

          link.setAttribute('download', self.product.item_identifier + '_' + image.sequence + '.' + 'jpg')
          document.body.appendChild(link)
          link.click()
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: 'Something went wrong',
            show: true
          })
        })
    },

    actionPendingProduct: function (image) {
      var self = this
      const url = '/retouchdesk/sessions/products/add'
      const id_products = []

      id_products.push(image.id_product)

      let data = {
        id_retouchdesk_session: 0,
        id_product: id_products.toString(),
        is_approve: 1
      }
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
            self.$store.dispatch('updateToast', {
              text: 'Image Requeued',
              show: true
            })
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('updateToast', {
            text: error.response,
            show: true
          })
        })
    },

    zoomImage: function (image) {
      var self = this
      var context = {
        content: image,
        contentType: 'image',
        show: true,
        type: this.type
      }
      this.$store.dispatch('updateModal', context)
    }
  }
}
</script>

<style>
.support-index .st-foot a.value span {
    border-bottom: none !important;
    color: #000;
    margin-right: 5px;
}
.small-detail {
    font-size: 11px;
}
</style>
